import { EditableCellV2 } from '../../../MedTableRenderer';
import { FlatInjectionObj } from '../../../../../../../../store/types/prescription';
import { Input } from 'antd';
import { INJECTION_COLUMN } from '../../../../../../../../utils/enums';
import { ChangeEvent } from 'react';
import { injectionRowHeaderMapping } from '../../../../../../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getInjectionElements } from '../../../../../../../../store/selectors/prescriptionPad';
import { upsertInjection } from '../../../../../../../../store/actions/prescriptionPad';

const InjectionInstruction = ({
    injection,
    columnKey,
    isDragMode,
}: {
    injection: FlatInjectionObj;
    columnKey: INJECTION_COLUMN;
    isDragMode: boolean;
}): JSX.Element => {
    const elements = useSelector(getInjectionElements);
    const dispatch = useDispatch();
    const onInstructionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const { is_added_drug, is_tapering_dose, currentIndex, mainIndex } = injection;
        const clonedElement = elements[mainIndex];
        if (is_added_drug) {
            if (clonedElement.added_drug?.[currentIndex]) {
                clonedElement.added_drug[currentIndex].instructions = e.target.value;
            }
        } else if (is_tapering_dose) {
            if (clonedElement.tapering_dose?.[currentIndex]) {
                clonedElement.tapering_dose[currentIndex].instructions = e.target.value;
            }
        } else {
            if (clonedElement) {
                clonedElement.instructions = e.target.value;
            }
        }
        dispatch(upsertInjection(clonedElement, mainIndex));
    };
    return isDragMode && (injection.is_added_drug || injection.is_tapering_dose) ? (
        <></>
    ) : (
        <div className="flex space-x-8 items-center">
            <EditableCellV2
                defaultValue={injection.instructions}
                label={injectionRowHeaderMapping[columnKey]}
            >
                <Input.TextArea
                    autoFocus
                    defaultValue={injection.instructions || ''}
                    rows={2}
                    placeholder="Add notes here"
                    onChange={onInstructionChange}
                />
            </EditableCellV2>
        </div>
    );
};

export default InjectionInstruction;
